t = require('app/scripts/views/internal/teacup-with-helpers')('popover_change_labels')

module.exports = ->
  t.input '.js-autofocus.js-label-search', { type: 'text', placeholder: t.l('search-labels-ellipsis'), value: t.mustacheVar('searchInit'), autocomplete: 'off' }

  t.div '.pop-over-section.js-suggestions', ->
    t.h4 ->
      t.icon 'sparkle'
      t.format 'suggested'
    t.ul '.edit-labels-pop-over.js-suggested-labels-list', ->
    t.a '.suggested-actions-feedback.js-suggested-actions-feedback', { href: '#' }, ->
      t.format 'feedback'

  t.div '.pop-over-section', ->
    t.h4 ->
      t.format 'labels'

    t.ul '.edit-labels-pop-over.js-labels-list'

    t.mustacheBlock '__ed', ->
      t.div ->
        t.a '.subtle.button.full.js-add-label', { href: '#' }, ->
          t.format 'create-a-new-label'
        t.a '.subtle.button.full.hide.js-show-more', { href: '#' }, ->
          t.format 'show-more-labels'
        t.hr()
        t.a '.subtle.button.full.js-toggle-color-blind-mode', { href: '#' }, ->
          t.mustacheBlock 'isColorBlindEnabled', ->
            t.format 'disable-color-blind-friendly-mode-no-punc'
          t.mustacheBlockInverted 'isColorBlindEnabled', ->
            t.format 'enable-color-blind-friendly-mode-no-punc'
